// src/components/LP.js
import React from 'react';

// トークンとユーティリティのCSSはアプリ全体で1回だけ読み込み
import '../globals.css';
import '../lp.css'; // 以前の index.css をコピーしてある場合だけ。無いならこの行は削除

// セクション
import { Navbar } from './lp/Navbar';
import { Hero } from './lp/Hero';
import { Stats } from './lp/Stats';
import { Features } from './lp/Features';
import { HowItWorks } from './lp/HowItWorks';
import { Pricing } from './lp/Pricing';
import { IndustrySpecific } from './lp/IndustrySpecific';
import { FAQ } from './lp/FAQ';
//import { Testimonials } from './lp/Testimonials';
import { CTA } from './lp/CTA';
import { Footer } from './lp/Footer';
import { ArchiveNotice } from './ArchiveNotice';

// Toaster（sonner）を使うなら上位に一度だけ
import { Toaster } from './lp/ui/sonner';

export default function LP() {
  return (
    <div className="min-h-dvh bg-background text-foreground">
      <ArchiveNotice variant="lp" />
      <Navbar />
      <Hero />
      <Stats />
      <Features />
      <HowItWorks />
      <Pricing />
      <IndustrySpecific />
      <FAQ />
      {/*<Testimonials />*/}
      <CTA />
      <Footer />
      <Toaster position="top-center" /> {/* 使わなければ削除可 */}
    </div>
  );
}
